import React from 'react'
import { ChallengeCardProps, RaceCardProps } from '..'
import { ProgressSection } from '../ProgressSection'
import { FlameSection } from './FlameSection'

type CardFooterProps = {
    title: string
    subtitle?: string
    type: 'race' | 'challenge'
    intensity?: 1 | 2 | 3
    trainers?: ChallengeCardProps['trainers']
    distance?: RaceCardProps['distance']
    progress: number
}

export const CardFooter = ({
    title = '',
    subtitle = '',
    type = 'race',
    trainers = [],
    distance = '',
    progress
}: CardFooterProps) => {
    return (
        <div className="absolute bottom-3 left-4 right-4 flex flex-col z-10">
            <div className="flex items-end justify-between">
                <div className="max-w-[150px]">
                    <p className="text-white text-lg font-medium line-clamp-2 leading-tight">
                        {title}
                    </p>
                    {type === 'race' && (
                        <p className="text-gray-400 text-xs font-normal">{distance}</p>
                    )}
                    <p
                        className={`text-xs ${
                            type === 'race'
                                ? 'text-yf-green font-medium'
                                : 'text-white font-light'
                        }`}
                    >
                        {subtitle}
                    </p>
                </div>
                {type === 'race' && (
                    <ProgressSection progress={progress} color="primary" />
                )}
                {type === 'challenge' && !trainers.length ? (
                    <ProgressSection progress={progress} color="secondary" />
                ) : null}
            </div>
            {trainers.length ? (
                <React.Fragment>
                    <div className="w-full h-[1px] bg-white bg-opacity-20 my-2" />
                    <div className="flex items-center justify-between">
                        <div className="flex justify-center flex-col">
                            {trainers.map((trainer, idx) => (
                                <div className="flex items-center" key={idx}>
                                    <FlameSection intensity={trainer.intensity} />
                                    <p className="text-xs text-white font-light leading-none">
                                        {trainer.name}
                                    </p>
                                </div>
                            ))}
                        </div>

                        <ProgressSection progress={progress} color="secondary" />
                    </div>
                </React.Fragment>
            ) : null}
        </div>
    )
}
